<script>
import { initDUOTEL } from '@/utils/thirdParties'
const globalErrorHandler = function() {
  console.log('global error ->', arguments)
}

export default {
  mounted() {
    initDUOTEL()
    window.addEventListener('error', globalErrorHandler)
    // 错误日志落库
    // const isPlaitObj = function(obj) {
    //   return Object.prototype.toString.call(obj) === '[object Object]'
    // }
    // this.$api.post('/api/v1/h5/adapter/frontconfig/share').then((data) => {
    //   // if (data.uuid === 'fc3072fdca7e58cc762c94c688b404fa') {
    //   if (data.uuid === 'ea2ff15c769a59763563cee7ebd10c3e') {
    //     window.debugBank = true
    //   }
    // })
    // const uri_ = ``
    // const track = function(json) {
    //   // h5内
    //   const url = Object.keys(json).reduce(function(_old, _new) {
    //     return `${_old}&${encodeURIComponent(_new)}=${isPlaitObj(json[_new]) ? JSON.stringify(json[_new]) : encodeURIComponent(json[_new])}`
    //   }, uri_)
    //   return fetch(url)
    // }
    // // eslint-disable-next-line no-console
    // const consoleLog = console.log
    // // eslint-disable-next-line no-console
    // console.log = function(...args) {
    //   if (window.debugBank) {
    //     // eslint-disable-next-line no-console
    //     console.warn(args)
    //     track({
    //       debug: true,
    //       type: 'console.log',
    //       args: JSON.stringify(args)
    //     })
    //   }
    //   consoleLog(...args)
    // }
  },
  beforeDestroy() {
    window.removeEventListener('error', globalErrorHandler)
  },
  render() {
    return <nuxt />
  }
}
</script>
